import React from 'react';
import FieldGenerico from '../componentes_generales/componentes_formulario/fields/fieldgenerico';
import FieldDate from '../componentes_generales/componentes_formulario/fields/fielddate/fielddate';
import FieldSelect from '../componentes_generales/componentes_formulario/fields/fieldselect/fieldselect';
import FieldSelectAsync from '../componentes_generales/componentes_formulario/fields/fieldselect/fieldselectasync';
import FieldGetSelectAsync from '../componentes_generales/componentes_formulario/fields/fieldselect/fieldgetselectasync';
import FieldBusqEspecifica from '../componentes_generales/componentes_formulario/fields/busqueda_especifica/fieldselectasync-busq-especif';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit,ContainerCol} from '../componentes_generales/componentes_formulario/contenedores/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { cargarCatalogos, cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { cargar_ValoresIniciales, cargar_IngresoBodega } from '../../actions/inventario/act_inven04';
import styled from 'styled-components';
import global_axios from '../../funciones_globales/interaccionapi';
import { completar_String, formatearNumeroDecimal, formatearNumeroEntero } from '../../funciones_globales/format';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { validarJSON, validarFechaTransaccionSeleccionada, validarPermisoAcceso, validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { multiplicarDecimales } from '../../funciones_globales/operacionesMatematicas';
import moment from 'moment';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/'; //Willy 2019-09-26
import ComponenteSolicitudAprobacion from '../componentes_generales/aprobaciones/ComponenteSolicitudAprobacion';
import io from "socket.io-client";
import { api as API_BASE_URL} from '../../config';

const LabelAprobado = styled.h6`
  color: red;
  font-weight: 600;
`
const ContenedorBotonAdd = styled.div`
  padding-top: 20px;
  @media (max-width: 991px) {
    padding: 0px;
  }
`;

const LabelTotal = styled.p`
  font-size: 11px;
  font-weight: bold;
`;

const LabelCabecera = styled.label`
  display: inline;
  font-size: 9px;
  color: green;
  margin-right: 15px;
  float: right;
`;

const TextoVerificacion = styled.div`
  font-size: 11px;
  color: #3c763d;
`;


const ContenedorVerificacion = styled.div`
  margin-top: 5px;
  padding: 8px;
  border: 1px solid #d6e9c6;
  border-radius: 4px;
  background-color: #dff0d8;
`;


const validate = values => {
  const errors = {}
  if (!values.codigo) {
    errors.codigo = 'Campo requerido'
  } 
  if (!values.tipo) {
    errors.tipo = 'Campo requerido'
  } 
  if (!values.bodega) {
    errors.bodega = 'Campo requerido'
  }  
  if (!values.fecha) {
    errors.fecha = 'Campo requerido'
  }
  if (!values.observacion) {
    errors.observacion = 'Campo requerido'
  }
  if (!values.proveedor) {
    errors.proveedor = 'Campo requerido'
  }
  return errors;  
}

class FormInven04 extends React.Component{   
  constructor(props) {
    super(props);
    this.state = {  
      estado_form:false,
      nivel:null,
      ip: API_BASE_URL,
      esAprobadorForm:false,
      modalVisible:false, 
      usuario_final:null,
      socket:null,
      mensajes:[],
      usuariosAprobadores:[],
      tipoSolicitud:'OI',
      transaccionId:null,
      puedeSolicitar:true,
      bloquearFormulario:false,
      file: null,
      esExcel:'N',
      nombreArchivo:'',
      usuarioConAprobacion:'N',
      operacion: 'G',
      datosMovimiento: null,
      optionsTiposIngreso:[{value: 'A', label: 'Afecta a Compra Importación'}, {value: 'S', label: 'Sistema selecciona compra'}],
      tiposingreso: [],
      bodegas: [],
      columnDefs: [ {   header: "No.",
                        field: "secuencia",
                        width: 75,
                        type: "string",
                        suppressFilter: true,
                        suppressSorting: true
                    },
                    {   header: "Cod. Artículo",
                        field: "articulo",
                        width: 100,
                        type: "string"                        
                    },
                    {   header: "Nombre Artículo",
                        field: "nombre",
                        width: 350,
                        type: "string"                        
                    },
                    {   header: "Cantidad",
                        field: "cantidad",
                        width: 100,
                        type: "num_entero_edit",
                        editable: true
                    },                 
                    {   header: "Costo Prom.",
                        field: "costopromedio",
                        width: 100,
                        type: "num_decimal_edit",
                        editable: true,
                        valueFormatter: this.formatearNumero
                    },
                    {   header: "Subtotal",
                        field: "subtotal",
                        width: 100,
                        type: "num_decimal",
                        valueGetter: (params) => {                          
                          let cantidad = params.data.cantidad===null?0:params.data.cantidad;
                          let costopromedio = parseFloat(params.data.costopromedio===null?0:params.data.costopromedio).toFixed(2);
                          return parseFloat(multiplicarDecimales(cantidad, costopromedio)).toFixed(4);
                        } 
                    },
                    {   header: "",
                        field: "eliminar",
                        width: 95,
                        type: "link_elim",
                        suppressFilter: true,
                        suppressSorting: true
                    }
                  ],
      data_articulos: [], 
      articulo: undefined ,
      total_ingreso: parseFloat(0.00)
    };
    this.gridOptions = {
      context: {
          componentParent: this
      },      
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      singleClickEdit: true,
      onRowDataChanged: ((event)=>{
        /* Cada vez que el grid de detalle sufra un cambio se recalculará el total */
        this.calculoTotal();
      }),      
      onCellValueChanged: ((event)=>{


        let valorAnterior = formatearNumeroEntero(event.oldValue);
        let valorNuevo = formatearNumeroEntero(event.newValue);        
        let columna = event.colDef.field;
        
        if (columna === 'cantidad'){

          if(isNaN(valorNuevo) || formatearNumeroEntero(valorNuevo)===0){
            alert('La cantidad que ingresó es incorrecta.');
            event.data.cantidad = valorAnterior;
          }
          
          this.api.refreshCells();
          this.calculoTotal();          
        }

        if (columna === 'costopromedio'){

          if(isNaN(valorNuevo) || formatearNumeroEntero(valorNuevo)===0){
            alert('El costo promedio que ingresó es incorrecto.');
            event.data.costopromedio = valorAnterior;
          }
          
          this.api.refreshCells();
          this.calculoTotal();
        }
      }),
    };

    this.onGridReady = this.onGridReady.bind(this);     
    this.inicializarComponentes = this.inicializarComponentes.bind(this);
    this.getArticulo = this.getArticulo.bind(this);
    this.getOptions_Articulos = this.getOptions_Articulos.bind(this);
    this.deleteItemArray = this.deleteItemArray.bind(this);
    this.generarReporte = this.generarReporte.bind(this);
    this.calculoTotal = this.calculoTotal.bind(this);
    this.fileUpload=this.fileUpload.bind(this);
    this.onChange= this.onChange.bind(this);
    this.mostrarModal= this.mostrarModal.bind(this);//Cambios Aprobacion 20191031
    this.addUserSolicitante = this.addUserSolicitante.bind(this);//Cambios Aprobacion 20191030
    this.actualizarUsuariosAprobadores = this.actualizarUsuariosAprobadores.bind(this);//Cambios Aprobacion 20191030
    this.desconectarUsuario= this.desconectarUsuario.bind(this);//Cambios Aprobacion 20191030
    this.bloquearFormularioAccion=this.bloquearFormularioAccion.bind(this);//Cambios Aprobacion 20191030
    this._ejecutarVerificacionMovimiento = this._ejecutarVerificacionMovimiento.bind(this);
    this.verificarMovimiento = this.verificarMovimiento.bind(this);
  }

  onChange(e) {
    this.setState({file:e.target.files[0]})
  }


  async _ejecutarVerificacionMovimiento(tipoIngreso, movimientoId) {
        const { cambiar_VisualizacionLoading } = this.props;
        try {
            const verificationData = {
                tipoTransf: tipoIngreso,
                movimientoId: movimientoId,
                
            };

            cambiar_VisualizacionLoading(true);
            const response = await global_axios({
                method: 'POST',
                url: '/ingresosbodega/verificar',
                data: verificationData
            });
            cambiar_VisualizacionLoading(false);
            return response.data; // { esValido, errores, datos }
        } catch (error) {
            cambiar_VisualizacionLoading(false);
            const errorMessage = error.response ? (error.response.data.errores ? error.response.data.errores.join('\n') : (error.response.data.msg || 'Error desconocido')) : error.message;
            return { esValido: false, errores: [errorMessage], datos: {} };
        }
    }



  fileUpload(){
    var data = {};
    var file= this.state.file;
        
    if(file!==null){
      if(file.name.length<=50){
         //Proceso para validar que el nombre del archivo no se encuentre ingresado anteriormente.
          let query = "?modulo=02&nombreArchivo="+ file.name +"&tipoTransaccion=OI"
          let config_request_validacion = {
            method: 'GET',
            url: 'validate/getValidacionLoteTransaccion'+query,
            headers: {'idregaudit': this.props.idRegAudit},
          };
          this.props.cambiar_VisualizacionLoading(true);
        
          global_axios(config_request_validacion)
          .then((validacion)=> { 
            this.props.cambiar_VisualizacionLoading(false);
            console.log(validacion.data)
            if(!validacion.data.encontrado){//Si no fue encontrado el nombre en la tabla log 20191021
              let cargar = window.confirm("¿El excel que va a ser cargado posee la siguiente estructura: ? \n 1) La hoja 1 del excel debe tener el nombre de INGRESO \n 2) El Excel debe tener más de 20 Artículos \n El Excel debe tener el siguiente formato: \n Fila 1: \n Columna A) Total Items \n Columna B) Valor Total Items (ej: 20) \n Columna C) Total Unidades \n Columna D) Valor Total Unidades (ej:180) \n Fila 2 en adelante: \n Columna A) Código Artículo (ej:AL021) \n Columna B) Cantidad (ej: 12)" ); 
              if(cargar){
              
                this.props.cambiar_VisualizacionLoading(true);
                const url = '/uploadsIngreso/ingresos';
                const usuario = getItemDatosSesion('usuario').toString();
                const IdRegAudit = this.props.idRegAudit;
            
                data.Usuario = usuario;
                data.IdRegAudit = IdRegAudit;
                const formData = new FormData();
                
                formData.append('file',file)
                formData.append('nombre','archivo')
                formData.append('Usuario', usuario)
                formData.append('IdRegAudit', IdRegAudit)
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data',
                    }
                    
                }
              global_axios.post(url,formData,config).then((response)=>{
                    let articulos = response.data.datosIngreso;
                    let secuencia= 0;      
                      for (let i=0; i< articulos.length; i++){
                            secuencia = secuencia +1;
                            articulos[i].secuencia= completar_String(secuencia.toString(), '0', 3);
                        }
                        this.setState({data_articulos:articulos, esExcel:'S', nombreArchivo:file.name})
                        this.props.cambiar_VisualizacionLoading(false);
                        alert("Se cargaron "+ response.data.itemsProcesados + "Items.")
                  
                }).catch((error)=>{
                  console.log(error)
                  this.props.cambiar_VisualizacionLoading(false);
                  alert(error.response?error.response.data.msg:error.message);
                })
              }
            }else{
              alert('El nombre del excel : '+file.name + ' ya se encuentra ingresado, por favor correguir para continuar.')
            }

          })
          .catch((error)=>{
            this.props.cambiar_VisualizacionLoading(false);
            alert(error.response?error.response.data.msg:error.message);
          })
      }else{
        alert('El nombre del archivo Excel solo puede tener 50 caracteres')
      }
    }else{
      alert("Debe seleccionar un archivo Excel.")
    }
  }

  calculoTotal(){
    let totalIngreso = 0;
    this.state.data_articulos.forEach((item)=>{
      let cantidad = item.cantidad===null?0:item.cantidad;
      let costopromedio = parseFloat(item.costopromedio===null?0:item.costopromedio).toFixed(2);
      totalIngreso = parseFloat(parseFloat(totalIngreso) + multiplicarDecimales(cantidad, costopromedio)).toFixed(4);
    });
    
    this.setState({total_ingreso: totalIngreso});
  }
  
  submit(e){
    if (this.state.data_articulos.length===0){
      alert('Ud. no ha especificado el detalle de los artículos a ingresar.');
      return;
    }

    let fechaIngBodega = e.fecha;
    if (!validarFechaMomentEnFormatoString(fechaIngBodega)){
      alert('La fecha del ingreso de bodega es inválida.');
      return;
    }

    let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
    if (!validPermiso.esValido){
      alert(validPermiso.msg);
      return;
    }

    let fechaProceso = getFechaProcesoPorModulo('02');
    if (this.props.permiteCambioFProceso==='S'){
      let validFProceso = validarFechaTransaccionSeleccionada(moment(fechaIngBodega, 'DD/MM/YYYY'), moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
      
      if(!validFProceso.esValida){
        alert(validFProceso.msg);
        return;
      }
    }
    let detalleArticulos = [];

    this.state.data_articulos.forEach(item=>{
      detalleArticulos.push({
        articulo: item.articulo,
        cantidad: item.cantidad,        
        costopromedio: item.costopromedio        
      })
    });
    //Cambios Aprobacion: Se Valida que se solicito una aprobacion (TransaccionNumber)
    if(this.state.transaccionId === null && !this.state.esAprobadorForm){
      alert("Solicite aprobación para continuar.")
      return;
    }
    //Se Procede a verificar si la transaccion ha sido aprobada.
    let data={
      transaccionId:this.state.transaccionId,
      tipo:this.state.tipoSolicitud,
      esUsuarioAprobador:this.state.esAprobadorForm
    };//Cambios Aprobacion 20191029 Willy
    let config_request_validar_transaccion = {
      method: 'POST',
      url: '/aprobaciontransaccion/validar_aprobacion',
      data,
    };
    this.props.cambiar_VisualizacionLoading(true);
    global_axios(config_request_validar_transaccion)//Cambios Aprobacion 20191029 Willy
    .then((respuesta)=> {
      this.props.cambiar_VisualizacionLoading(false);
      if(respuesta.data.puedeGuardar){//Cambios Aprobacion 20191029 Willy
        try {
          //Cambios Aprobacion 20191029 Willy
          //PROCESO PARA ALMACENAR TSN EN CASO DE SER UN ADMINISTRADOR.
          let datos= {};
          if(this.state.esAprobadorForm){
           datos.SolicitudAprobacionTransaccion={};
           datos.ComprobanteInventario={};
           //PARA SOLICITUD APROBACION TRANSACCION
           datos.SolicitudAprobacionTransaccion.Modulo=this.props.formulario.substring(0, 2);
           datos.SolicitudAprobacionTransaccion.TipoComprobante = this.state.tipoSolicitud; //transferencia.
           datos.SolicitudAprobacionTransaccion.Motivo= e.observacion;
           datos.SolicitudAprobacionTransaccion.TotalRegistros= parseInt(this.state.data_articulos.length,10);
           datos.SolicitudAprobacionTransaccion.TotalValores=parseFloat(this.state.total_ingreso);
           datos.SolicitudAprobacionTransaccion.UsuarioSolicitaAprob= this.state.usuario_final.UsuarioId;
           //PARA COMPROBANTE INVENTARIO.
           datos.ComprobanteInventario.TipoComprobante= this.state.tipoSolicitud; //ingreso.
           datos.ComprobanteInventario.BodegaDestino= e.bodega;
           datos.ComprobanteInventario.BodegaOrigen = e.bodega;
           datos.ComprobanteInventario.Detalle= [];
           //PARA DETALLE DE COMPROBANTE INVENTARIO.
           for(let j=0; j<this.state.data_articulos.length; j ++){
             let articulo = {};
             let consecutivo = j+1;
             articulo.TipoComprobante= this.state.tipoSolicitud;
             articulo.Consecutivo= consecutivo;
             articulo.Articulo= this.state.data_articulos[j].articulo;
             articulo.Cantidad= this.state.data_articulos[j].cantidad;
             articulo.CostoPromedio= this.state.data_articulos[j].costopromedio;
             datos.ComprobanteInventario.Detalle.push(articulo)
           }
          }
          let data = {
            codigo: e.codigo,
            tipo: e.tipo,
            proveedor: e.proveedor.value,
            observacion: e.observacion,
            importe: parseFloat(this.state.total_ingreso),
            fecha: e.fecha,
            bodega: e.bodega,
            movimientoId: e.movimientoId,
            tipoIngreso: e.tipoIngreso,
            usuario: getItemDatosSesion('usuario').toString(),
            det_ingreso: detalleArticulos,
            moneda: JSON.parse(getItemDatosSesion('moneda')).Moneda,
            dolar: JSON.parse(getItemDatosSesion('moneda')).Cotizacion,
            esExcel:this.state.esExcel, //Willy 2019-09-26
            modulo:'02',//Willy 20191021
            nombreArchivo:this.state.nombreArchivo,//Willy 20191021
            totalItems:this.state.data_articulos.length,//Willy 20191021
            esUsuarioAprobador:this.state.esAprobadorForm,//Cambios Aprobacion 20191031
            transaccionNumber:this.state.transaccionId,//Cambios Aprobacion 20191031
            datos:datos//Cambios Aprobacion 20191031
          }
    
          if (this.state.operacion === 'M'){
            data.tipo_act = 'CAMBIO_DATA';
          }
      
          let config_request = {
            method: (this.state.operacion==='G') ? 'POST' : 'PUT',
            url: ((this.state.operacion==='G') ? '/ingresosbodega': '/ingresosbodega/' + data.codigo),
            data,
            headers: {'idregaudit': this.props.idRegAudit},
          };
          
          global_axios(config_request)
          .then(()=> {
            this.props.cambiar_VisualizacionLoading(false);
            alert('El ingreso de bodega se registró/actualizó correctamente.');
            this.inicializarComponentes();
          })
          .catch((error)=>{
            this.props.cambiar_VisualizacionLoading(false);
            alert(error.response?error.response.data.msg:error.message);
          });
    
        } catch (error) {
          this.props.cambiar_VisualizacionLoading(false);
          alert(`Ocurrió un error al intentar guardar el Ingreso de Bodega. Error: ${error}`);
        }
      }else{
        alert('La solicitud realizada no posee aprobación, no se puede continuar...')
      }
    })
    .catch((error)=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    })
  }

  componentDidMount() {
    Promise.all([        
        cargarCatalogos('TIPOINGRES'),
        cargarCatalogos('BODEGA'),
        getItemDatosSesion('usuario'),
        getItemDatosSesion('nivel'),//Willy 20191112 ->cambio mostrar columna de costos por niveles
        this.props.generar_LogAuditoriaIngresoForm('0204')
    ])
    .then(([result_tiposingresos, result_bodegas, usuario,nivel]) => {
      this.setState(
        { tiposingreso: result_tiposingresos,
          bodegas: result_bodegas,
          nivel
        });
        //SE OBTIENE EL SECUENCIAL DE APROBACION TRANSFERENCIA.
        global_axios({
          method: 'GET',
          url: '/secuenciales/TransaccionNumber'
        })
        .then( response => {
          let cod_secuencial = response.data.codigo;
          this.setState({transaccionNumber:cod_secuencial},()=>{
            global_axios({
              method: 'GET',
              url: '/usuarios/' + usuario
            })
            .then( response => {
              //Se procede a verificar si el usuario es aprobador
              global_axios({
                method: 'GET',
                url: '/usuarios/aprobador/' + usuario
              })
              .then( (aprobador) => {
                //Se procede a verificar si el usuario es aprobador
                if(aprobador.data!==null){
                  let encontrado=false;
                  for(let i=0; i<aprobador.data.detAprobaciones.length; i++){
                    if(aprobador.data.detAprobaciones[i].CodigoFormulario==='0204'){
                        encontrado=true;
                    }
                  }
                  if(encontrado){
                    this.setState({esAprobadorForm:true})
                  }
                }
                this.setState({usuario_final : response.data})
              })
              .catch((error)=>{
                alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);  
              })
            })
            .catch((error)=>{
              alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);  
            })
          })
        })
      .catch(error=>{
        alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);  	
      });
      let fechaProceso = getFechaProcesoPorModulo('02');
      this.props.cargar_ValoresIniciales(fechaProceso);

      var socket= io(this.state.ip,{transports:['websocket'],upgrade:false});
      this.setState({socket:socket});
      if(nivel>2){
        this.columnApi.setColumnsVisible(['costopromedio','subtotal'], false);
      }
    });
  }   
  
  componentWillMount(){
    this.props.generar_LogAuditoriaSalidaForm('0204');
  }

  getOptions_IngresosBodega(input, callback){
    if (input.toString().length >= 3 ){
      let cadena_busq = '?cadena_busq=' + input;
      cargarCatalogosGenericoAsync('/ingresosbodega', cadena_busq, callback)  
    }
  }

  getOptions_Articulos(input, callback){
    if (input.toString().length >= 3 ){
      let query = "?tipo=catalogo&cadena_busq=" + input;     
      cargarCatalogosGenericoAsync('/articulos', query, callback)
    }
  }  

  getOptions_Proveedores(input, callback){
    if (input.toString().length >= 3 ){
      let cadena_busq = "?tipo=catalogo&cadena_busq=" + input;
      cargarCatalogosGenericoAsync('/proveedores', cadena_busq, callback)  
    }
  } 

  getIngresoBodega(){
    if (this.props.codigo_ingreso === undefined){
      alert('Ud. no ha seleccionado el ingreso de bodega que desea consultar.');
    }else{
      const codigo_ingreso= this.props.codigo_ingreso.value;
      this.props.cargar_IngresoBodega(codigo_ingreso).then(()=>{
        if (this.props.initialValues!==null && this.props.initialValues!==undefined
          && this.props.detalle_ingreso!==null && this.props.detalle_ingreso!==undefined){
          this.props.detalle_ingreso.forEach((det)=> {
            det.nombre = det.art.nombre;
          });

          this.setState({ 
            data_articulos: this.props.detalle_ingreso,
            operacion: 'M'});
        }
      });
    }
  }

  formatearNumero(params){
    return parseFloat(params.value).toFixed(4).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  addArticulo(){   
    if (!this.state.articulo){
      alert('Ud. no ha seleccionado el artículo que desea añadir.');    
    }else if (!this.props.cantidad){
      alert('Ud. no ha indicado la cantidad del artículo que desea añadir.');      
    } else {

      const articulo = this.state.articulo;
      const cantidad = this.props.cantidad;
      
      if (!(Number.isInteger(Number(cantidad))) || parseInt(cantidad, 10)<=0){
        alert('La cantidad que desea ingresar es inválida.');
        return;
      }else{
        let costopromedioIngresado= 0;
        let costopromedio=articulo.costopromedio;
        if(articulo.costopromedio===0 || articulo.costopromedio===''){//20191112 ->cambio de costo promedio = 0
          while (costopromedioIngresado === 0 || costopromedioIngresado<0|| (costopromedioIngresado != null && isNaN(costopromedioIngresado))) {
            costopromedioIngresado= parseFloat(prompt("El valor de costo promedio es 0, Ingrese un valor mayor a 0"));
          }
          costopromedio= costopromedioIngresado;
        }
        let item_articulo = {};
        let nro_item = this.state.data_articulos.length + 1;
        item_articulo.secuencia= completar_String(nro_item.toString(), '0', 3);
        item_articulo.articulo=articulo.codigo;
        item_articulo.nombre=articulo.descripcion;
        item_articulo.cantidad=formatearNumeroEntero(cantidad);
        item_articulo.costopromedio=costopromedio;

        let existe_articulo = false;
        this.state.data_articulos.forEach((item)=>{
          if (item.articulo === item_articulo.articulo){
            existe_articulo = true;
          }
        });

        if (!existe_articulo){          
          this.setState({ data_articulos: [...this.state.data_articulos, item_articulo]});
          this.calculoTotal();
        }else{
          alert('El artículo: ' + item_articulo.articulo + ' ya fue añadido.')
        }     
      }      
    }       
  }

  deleteItemArray (arr, index) {
    let indice = parseInt(index, 10);
    let arr_tmp = arr.slice(0, indice).concat(arr.slice(indice+1));    
    arr_tmp.forEach((item, i)=>{
      item.secuencia = completar_String((i + 1).toString(), '0', 3);      
    });    
    return arr_tmp;
  }  


   verificarMovimiento() {
        const { tipoIngreso_valor, movimientoId , touch} = this.props;
        this.setState({ datosMovimiento: null });
      console.log('AquiEqgreso')
      console.log(tipoIngreso_valor)
      console.log(movimientoId)

      if (!tipoIngreso_valor) {
            touch('form_inven04', 'tipoIngreso');            
            return;
        }
      this.setState({ datosMovimiento: null });

        if (tipoIngreso_valor === 'A'  && movimientoId) {
            this._ejecutarVerificacionMovimiento(tipoIngreso_valor, movimientoId)
                .then(({ esValido, errores, datos }) => {
                    if (!esValido) {
                        alert('Errores de validación:\n' + errores.join('\n'));
                    } else {
                        this.setState({ datosMovimiento: datos });
                    }
                });
        }
    }


  methodFromParent(id, datos_fila) {
    let eliminar = window.confirm('¿Está seguro de eliminar el artículo: ' + datos_fila.articulo + '?');          
    if (eliminar){     
      this.setState({ data_articulos: this.deleteItemArray(this.state.data_articulos, id)} );
      this.calculoTotal();
    }
  }
  
  onGridReady(params) {
    this.api = params.api;
    this.columnApi = params.columnApi;
  }

  inicializarComponentes(){
    this.props.reset();
    let fechaProceso = getFechaProcesoPorModulo('02');
    this.props.cargar_ValoresIniciales(fechaProceso);
    this.columnApi.setColumnsVisible(['eliminar'], true)//Cambios Aprobacion
    this.setState({ data_articulos: [],
                    operacion: 'G',
                    esExcel:'N',
                    usuarioConAprobacion:'N',
                    nombreArchivo:'',
                    transferenciaId:null,
                    modalVisible:false,
                    puedePresionarBotonSolcitud:true,
                    transaccionId:null,
                    bloquearFormulario:false,
                    estado_form:false,
                    datosMovimiento: null
                   });
  }

  addUserSolicitante(socket){
    return new Promise((resolve, reject) => {
      var user=getItemDatosSesion('usuario').toString();
      //Se emite el evento de añadir al usuario al registro de usuarios en el servidor
      var usuario={};
      usuario.usuario=user;
      usuario.nombre= this.state.usuario_final.NombreUsuario;
      usuario.codigo_formulario= this.props.formulario;
      socket.emit("addUserSolicitante", usuario);
      socket.on("confirmacionIngresoUsuario",function(data){
        resolve(data)
      })
    });
  }

  actualizarUsuariosAprobadores(){
    new Promise((resolve, reject) => {
      this.state.socket.emit("actualizarUsuariosAprobadores","");
      this.state.socket.on("actualizarUsuariosAprobadores",function(data){
        resolve(data)
      })
    }).then((datos)=>{
        let usuariosAprobadores=[];
        for(let i =0; i < datos.usuariosAprobadoresTransferencia.length ; i++){
          let formularios= datos.usuariosAprobadoresTransferencia[i].detAprobaciones; //Contiene todos los formularios que puede aprobar el usuario Aprobador.
          let encontradoFormulario= false;
            //Se recorre el arreglo interno de formularios aprobacion del objeto usuariosAprobadoresTransferencia
            for(let j=0; j< formularios.length; j++){
              if(formularios[j].CodigoFormulario===this.props.formulario){
              encontradoFormulario=true;
              }
            }
            if(encontradoFormulario){
              let usuario={}
              let loginArray=(datos.usuariosAprobadoresTransferencia[i].usuario!==null&& datos.usuariosAprobadoresTransferencia[i].usuario!==undefined)?datos.usuariosAprobadoresTransferencia[i].usuario.trim():'';
              let loginUsuario=(this.state.usuario_final.Login!==null && this.state.usuario_final.Login!== undefined)?this.state.usuario_final.Login.trim():''
              if(loginArray!== loginUsuario){ 
                usuario.value=datos.usuariosAprobadoresTransferencia[i].socketId;
                usuario.label=datos.usuariosAprobadoresTransferencia[i].nombre;
                usuario.usuario=(datos.usuariosAprobadoresTransferencia[i].usuario!==null && datos.usuariosAprobadoresTransferencia[i].usuario!==undefined)?datos.usuariosAprobadoresTransferencia[i].usuario.trim():'';
                usuariosAprobadores.push(usuario)
              }
              
            } 
        }
        this.setState({usuariosAprobadores})
       
    });
  }

  desconectarUsuario(socket){
    clearInterval(this.state.interval)
    var user=getItemDatosSesion('usuario').toString();
    var usuario={};
    usuario.usuario=(user!==null && user!==undefined)?user.trim():'';
    socket.emit('deleteUserSolicitante',usuario)
    socket.on("confirmacionEliminacionUsuario",function(data){
      console.debug("Se recibió mensaje via socket de confirmacionEliminacionUsuario: ", data);
    })
    this.apagarEventosSocket(socket);
    this.setState({puedeSolicitar:true});
  }

  cerrarModal(socket){
    if(this.state.puedeSolicitar){
      let confirmacion = window.confirm(`¿Está seguro que desea salir del chat, recuerde que si aun no le responden, debera solicitar nuevamente la aprobación.?`);
      if (confirmacion){
          console.log(this.state.usuario_final)
          socket.emit("limpiarArraySolicitudes",{
              desde_username:this.state.usuario_final.Login,
              transaccion_id:this.state.transaccionId,
              tipo:this.state.tipoSolicitud
          });
        this.setState({modalVisible: false})
        this.desconectarUsuario(socket)
      }
    }else{
      socket.emit("limpiarArraySolicitudes",{
          desde_username:this.state.usuario_final.Login,
          transaccion_id:this.state.transaccionId,
          tipo:this.state.tipoSolicitud
      });
      this.setState({modalVisible: false});
      this.desconectarUsuario(socket)
    }
     let data={
      transaccionId:this.state.transaccionId,
      tipo:this.state.tipoSolicitud,
      esUsuarioAprobador:this.state.esAprobadorForm
    };
    let config_request_validar_transaccion = {
      method: 'POST',
      url: '/aprobaciontransaccion/validar_aprobacion',
      data,
    };

    this.props.cambiar_VisualizacionLoading(true);
    global_axios(config_request_validar_transaccion)
      .then((respuesta)=> {
        console.log(respuesta)
        this.props.cambiar_VisualizacionLoading(false);
        this.setState({estado_form:respuesta.data.puedeGuardar})
    
      })
      .catch((error)=>{
        this.props.cambiar_VisualizacionLoading(false);
        alert(error.response?error.response.data.msg:error.message);
      })
  }

  apagarEventosSocket(socket){
    socket.off('confirmacionIngresoUsuario')
    socket.off('actualizarUsuariosAprobadores')
    socket.off('recibirMensajes')
    socket.off('comprobacionEnvio')
    socket.off('confirmacionEstadoTransaccion')
    socket.off('confirmacionEliminacionUsuario')
  }

  bloquearFormularioAccion(){
    this.columnApi.setColumnsVisible(['eliminar'], false)
    this.setState({bloquearFormulario:true})
  }

  mostrarModal(){
    let e = Object.assign({}, this.props)
    console.log(e)
    if (this.state.data_articulos.length===0){
      alert('Ud. no ha detallado los artículos a ingresar.')
      return;
    }
    if(e.tipo === undefined || e.tipo=== null){
        alert('Seleccione un tipo para continuar')
        return;
    }
    if (e.bodega===undefined){
      alert('Seleccione una bodega de Ingreso.')
      return;
    }
    if(e.proveedor===undefined || e.proveedor=== null){
      alert('Seleccione un proveedor')
      return;
    }
    if(e.observacion===undefined || e.observacion=== null){
      alert('Escriba una observación')
      return;
    }
    let fechaIngreso = e.fechaIngreso;
    if (!validarFechaMomentEnFormatoString(fechaIngreso)){
      alert('La fecha de la transferencia es inválida.');
      return;
    }
    
    let fechaProceso = getFechaProcesoPorModulo('02');
    if (this.props.permiteCambioFProceso==='S'){
      let validFProceso = validarFechaTransaccionSeleccionada(moment(fechaIngreso, 'DD/MM/YYYY'), moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
      
      if(!validFProceso.esValida){
        alert(validFProceso.msg);
        return;
      }
    }

    this.addUserSolicitante(this.state.socket).then((data)=>{
      //Se añaden los usuariosAprobadores
      let isVisible=false;
      let usuariosAprobadores=[];
      if(data.acceso){//Garantiza que se tenga acceso al modal debido a que solo se puede conectar desde una pantalla.
        if(data.usuariosAprobadoresTransferencia.length>0){
          //Se recorre los usuariosAprobadoreTransferencia para verificar que los aprobadores conectados poseean permisos de aprobación para el formulario del cliente Solicitante en este caso form (0202)
          for(let i =0; i < data.usuariosAprobadoresTransferencia.length ; i++){
             let usuario={};
             let formularios= data.usuariosAprobadoresTransferencia[i].detAprobaciones; //Contiene todos los formularios que puede aprobar el usuario Aprobador.
             let encontradoFormulario= false;
             //Se recorre el arreglo interno de formularios aprobacion del objeto usuariosAprobadoresTransferencia
             for(let j=0; j< formularios.length; j++){
               if(formularios[j].CodigoFormulario===this.props.formulario){
                encontradoFormulario=true;
               }
             }
             if(encontradoFormulario){
                usuario.value=data.usuariosAprobadoresTransferencia[i].socketId;
                usuario.label=data.usuariosAprobadoresTransferencia[i].nombre;
                usuario.usuario=(data.usuariosAprobadoresTransferencia[i].usuario!==null && data.usuariosAprobadoresTransferencia[i].usuario!==undefined)?data.usuariosAprobadoresTransferencia[i].usuario.trim():'';
                usuariosAprobadores.push(usuario)
            } 
          }
          if(usuariosAprobadores.length>0){//Se abrira el modal y se guardara lo que se ha hecho en el formulario en una tabla.}
              //PROCESO PARA ALMACENAR EN BD LO QUE SE HA HECHO EN EL FORMULARIO.
              let datos= {};
              datos.SolicitudAprobacionTransaccion={};
              datos.ComprobanteInventario={};
              //PARA SOLICITUD APROBACION TRANSACCION
              datos.SolicitudAprobacionTransaccion.Modulo=e.formulario.substring(0, 2);
              datos.SolicitudAprobacionTransaccion.TipoComprobante = this.state.tipoSolicitud; //transferencia.
              datos.SolicitudAprobacionTransaccion.Motivo= e.observacion;
              datos.SolicitudAprobacionTransaccion.TotalRegistros= parseInt(this.state.data_articulos.length,10);
              datos.SolicitudAprobacionTransaccion.TotalValores=parseFloat(this.state.total_ingreso);
              datos.SolicitudAprobacionTransaccion.UsuarioSolicitaAprob= this.state.usuario_final.UsuarioId;
              //PARA COMPROBANTE INVENTARIO.
              datos.ComprobanteInventario.TipoComprobante= this.state.tipoSolicitud; //transferencia.
              datos.ComprobanteInventario.BodegaDestino= e.bodega;
              datos.ComprobanteInventario.BodegaOrigen = e.bodega;
              datos.ComprobanteInventario.Detalle= [];
              //PARA DETALLE DE COMPROBANTE INVENTARIO.
              for(let j=0; j<this.state.data_articulos.length; j ++){
                let articulo = {};
                let consecutivo = j+1;
                articulo.TipoComprobante= this.state.tipoSolicitud;
                articulo.Consecutivo= consecutivo;
                articulo.Articulo= this.state.data_articulos[j].articulo;
                articulo.Cantidad= this.state.data_articulos[j].cantidad;
                articulo.CostoPromedio= this.state.data_articulos[j].costopromedio;
                datos.ComprobanteInventario.Detalle.push(articulo)
              }
              let config_request = {
                method: 'POST',
                url:  '/aprobaciontransaccion/',
                data:datos,
              };
              this.props.cambiar_VisualizacionLoading(true);
              global_axios(config_request)
              .then((response)=> {
                  this.props.cambiar_VisualizacionLoading(false);
                  isVisible=true;
                  this.setState({usuariosAprobadores,transaccionId:response.data.codigo},()=>{
                  this.setState({modalVisible:isVisible})
                })
                
              })
              .catch((error)=>{
                this.props.cambiar_VisualizacionLoading(false);
                this.desconectarUsuario(this.state.socket)
                alert(error.response?error.response.data.msg:error.message);
              })
          }else{
            this.desconectarUsuario(this.state.socket)
            //ENVIO DE SMS PARA USUARIOS APROBADORES
            let confirmacion = window.confirm(`¿No existen usuarios en linea. Desea enviarles un mail.?`);
            if (confirmacion){
              //proceso para enviar mail de usuarios aprobadores.
              let config_request_notificacion = {
                method: 'GET',
                url: '/aprobaciontransaccion/enviar_notificacion/'+this.props.formulario
              };
              this.props.cambiar_VisualizacionLoading(true);
              global_axios(config_request_notificacion)
              .then((respuesta)=>{
                this.props.cambiar_VisualizacionLoading(false); 
                alert(respuesta.data.msg)
                
              })
              .catch((error)=>{
                this.props.cambiar_VisualizacionLoading(false);
              })
              
            }
          }
        }else{
          //ENVIO DE SMS PARA USUARIOS APROBADORES
          let confirmacion = window.confirm(`¿No existen usuarios en linea. Desea enviarles un mail.?`);
          if (confirmacion){
            let config_request_notificacion = {
              method: 'GET',
              url: '/aprobaciontransaccion/enviar_notificacion/'+this.props.formulario
            };
            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request_notificacion)
            .then((respuesta)=>{
              this.props.cambiar_VisualizacionLoading(false); 
              alert(respuesta.data.msg)
              
            })
            .catch((error)=>{
              this.props.cambiar_VisualizacionLoading(false);
            })
            
          }
        }
      }else{
        alert("El Usuario ya posee una sesión iniciada")
      }
    })

    this.state.socket.on("comprobacionEnvio",function(data){
      var mensajes= this.state.mensajes;
      let fecha=new Date();
      data.fecha=String(fecha.getDate())+'/'+String((fecha.getMonth()+1))+'/'+String(fecha.getFullYear());
      data.hora=String(fecha.getHours())+':'+String(fecha.getMinutes())+':'+String(fecha.getSeconds());
      if(mensajes.length>0){
        let encontrado=false;
        for(let i=0; i<mensajes.length;i++){
          if(mensajes[i].contadorMensajes===data.contadorMensajes && mensajes[i].para===data.para && mensajes[i].mensaje=== data.mensaje){
            encontrado=true;
          }
        }
        if(!encontrado){
          mensajes.push(data);
          this.setState({mensajes})
        }
      }else{
        mensajes.push(data);
        this.setState({mensajes})
      }
      
      
    }.bind(this))
    //Detecta desconeccion del socket
    this.state.socket.on('disconnect',function(){
      console.log("Socket Desconectado...")
      this.setState({modalVisible:false, puedeSolicitar:true})
      this.apagarEventosSocket(this.state.socket)
    }.bind(this))


    //Proceso para recibir las confirmaciones de los estado de transaccion.
    this.state.socket.on("confirmacionEstadoTransaccion",function(data){
      var mensajes= this.state.mensajes;
      let fecha= new Date();
      var objeto={
        contadorMensajes: data.contadorMensajes,
        desde: data.desde,
        mensaje:data.mensaje,
        para:data.para,
        observacion:data.observacion,
        fecha:String(fecha.getDate())+'/'+String((fecha.getMonth()+1))+'/'+String(fecha.getFullYear()),
        hora:String(fecha.getHours())+':'+String(fecha.getMinutes())+':'+String(fecha.getSeconds()),
      }
      if(mensajes.length>0){
        let encontrado=false;
        for(let i=0; i<mensajes.length;i++){
          if(mensajes[i].contadorMensajes===data.contadorMensajes && mensajes[i].para===data.para && mensajes[i].mensaje=== data.mensaje){
            encontrado=true;
          }
        }
        if(!encontrado){
          mensajes.push(objeto);
          this.setState({mensajes})
        }
      }else{
        mensajes.push(objeto);
        this.setState({mensajes})
      }
      if(data.procesada){
        //Se bloquea el boton de solicitar del modal
        this.setState({puedeSolicitar:false})
      }
      if(data.aprueba){
        //Se bloquea el formulario si todo fue aprobado.
        this.bloquearFormularioAccion();
      }
     
    }.bind(this))

    //Se ejecuta el metodo para que envie cada X tiempo
     let tiempo = 5000;
     let interval=setInterval(this.actualizarUsuariosAprobadores,tiempo)
     this.setState({interval})
  }
  
  getArticulo(){
    let articulo = this.props.articulo;
    if (validarJSON(articulo)){      
      global_axios({
        method: 'GET',
        url: '/articulos/' + articulo.value,
      })
      .then((response)=> {
        this.setState({ articulo: response.data });        
      })
      .catch((error)=> {
        alert(error.response?error.response.data.msg:error.message);
      })
    }
  }

  generarReporte(){    
    if ((!this.props.ingresoBodegaId) || this.state.operacion!=='M') {
      alert('Ud. no ha seleccionado el Ingreso de Bodega que desea imprimir.');
      return;
    }    

    visualizarReporteEnPdf('&rpt=25&param1=' + this.props.ingresoBodegaId);
  }

  render(){
        const { handleSubmit, submitting } = this.props
        return(
          <ContenedorForm porc_ancho={70}>
            <HeaderForm>
              <TituloForm>Ingreso de Bodega</TituloForm>
              <LabelCabecera>Tsn: {this.state.transaccionNumber}</LabelCabecera> 
            </HeaderForm>
            <CuerpoForm>
              <ContainerEdit>
                <Row>
                  <div className='col-md-6'>
                    <Field
                      label="Ingreso de Bodega:"
                      name="ingreso"
                      component={ FieldBusqEspecifica }                                    
                      loadOptions={this.getOptions_IngresosBodega.bind(this)}
                      getItemEspecifico={this.getIngresoBodega.bind(this)}
                      func_OnFocus={this.inicializarComponentes}
                      textoBoton="Sel."
                      icono="fa fa-check-circle-o"/>
                  </div>
                  <div className='col-md-6'>
                    <ContainerCol className='col-sm-4' isInvisible={ this.state.esAprobadorForm}>
                      <LabelForm>Estado Petición:</LabelForm>
                      <LabelAprobado>{this.state.estado_form?'Aprobado':'Sin Aprobar'}</LabelAprobado>
                    </ContainerCol>
                  </div>
                </Row>             
              </ContainerEdit>                                                                               
              <form onSubmit={handleSubmit(this.submit.bind(this))}>                
                <Row>
                  <div className='col-md-2'>
                    <Field
                      name="codigo"
                      type="text"
                      component={ FieldGenerico }
                      label="Código:"
                      placeholder="Código"
                      readonly={true}/>
                  </div>
                  <div className='col-md-4'>
                    <Field
                      name="tipo"
                      component= { FieldSelect }
                      label="Tipo:"
                      options={ this.state.tiposingreso }
                      disabled={this.state.bloquearFormulario}/>
                  </div>  
                  <div className='col-md-4'>
                    <Field
                      name="bodega"
                      component= { FieldSelect }
                      label="Bodega:"
                      options={ this.state.bodegas }
                      disabled={this.state.bloquearFormulario}/>
                  </div>                   
                  <div className='col-md-2'>
                    <Field
                      name="fecha"
                      component={ FieldDate }
                      label="Fecha:"
                      placeholder="dd/mm/aaaa"
                      readOnly={!(this.props.permiteCambioFProceso==='S')}
                      disabled={this.state.bloquearFormulario}/>
                  </div>       
                </Row>
                <Row>
                  <div className='col-md-6'>
                    <Field
                      name="proveedor"
                      component= { FieldSelectAsync }
                      label="Proveedor:"                     
                      loadOptions={ this.getOptions_Proveedores.bind(this) }
                      disabled={this.state.bloquearFormulario}/>
                  </div>    
                  <div className='col-md-6'>
                    <Field
                      name="observacion"
                      type="text"
                      component={ FieldGenerico }
                      label="Observación:"
                      placeholder="Observación"
                      disabled={this.state.bloquearFormulario}
                      />
                  </div>                    
                </Row> 
                <Row>
                                <div className='col-md-6'>
                                    <Field
                                        name="tipoIngreso"
                                        component= { FieldSelect }
                                        label="Tipo Ingreso:" 
                                        options={ this.state.optionsTiposIngreso}
                                        disabled={this.state.bloquearFomulario}/>
                                </div>
                                                  <div className='col-md-6'>
                                                    {(this.props.tipoIngreso_valor === 'A') &&
                                                        <Field
                                                            name="movimientoId"
                                                            type="text"
                                                            component={ FieldGenerico }
                                                            label={"Id. Importación:" }
                                                            disabled={this.state.bloquearFomulario}
                                                            func_OnBlur={this.verificarMovimiento}/>
                                                    }
                                                    {this.state.datosMovimiento &&
                                                        <ContenedorVerificacion>
                                                            {
                                                                <TextoVerificacion>
                                                                    <strong>Lote:</strong> {this.state.datosMovimiento.lote} <br/>
                                                                    <strong>Proveedor:</strong> {this.state.datosMovimiento.proveedor}
                                                                </TextoVerificacion>
                                                            }
                  
                                                        </ContenedorVerificacion>
                                                    }
                                                  </div>                            </Row>              <Row></Row>


                
                <Row>
                  <div className='col-md-8'>
                    <Field
                      label="Artículo:"
                      name="articulo"
                      component={ FieldGetSelectAsync }                                   
                      loadOptions={this.getOptions_Articulos}
                      funcAdicional_OnBlur={this.getArticulo}
                      disabled={this.state.bloquearFormulario}/>                                          
                  </div>   
                  <div className='col-md-2'>
                    <Field
                      name="cantidad_item"
                      type="number"
                      component={ FieldGenerico }
                      label="Cantidad:"
                      disabled={this.state.bloquearFormulario}/>
                  </div>                    
                  <div className='col-md-2'>                    
                    <ContenedorBotonAdd>
                      <button type="button" disabled={this.state.bloquearFormulario}  className='btn btn-success btn-sm' onClick={this.addArticulo.bind(this)}><i className="fa fa-plus"></i></button>
                    </ContenedorBotonAdd>
                  </div>
                </Row>
                <Row>                 
                    <ContainerCol className='col-md-5'>
                        <LabelForm>Buscar archivo:</LabelForm>
                        <input id='archivo' type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={this.onChange}/>
                    </ContainerCol>
                    <ContainerCol className='col-md-3' margen_arriba={15}>             
                        <button  disabled={this.state.bloquearFormulario} type="button" className='btn btn-primary btn-sm' onClick={this.fileUpload}><i className="fa fa-refresh"> Cargar Excel</i></button>
                    </ContainerCol>
                </Row>
                <Row>
                  <div className='col-md-12'>   
                    <AgGridRender altura='200px' data={this.state.data_articulos} columnas={this.state.columnDefs} 
                      gridOptions={this.gridOptions} onGridReady={this.onGridReady}/>  
                  </div>
                </Row>                   
                <Row>
                  <div className='col-md-12'>
                    <div className="pull-right">                               
                      <LabelTotal>{'Total Ingreso: ' + formatearNumeroDecimal(this.state.total_ingreso)}</LabelTotal>
                    </div>
                  </div>
                </Row>
                <Row>                  
                  <div className='col-md-12'>
                    <div className='btn-group pull-right'>
                      <button type='submit' className='btn btn-primary btn-sm' disabled={submitting}>
                        <i className='fa fa-floppy-o fa-lg'></i> Guardar
                      </button>
                      <button type='button' className='btn btn-info btn-sm' onClick={this.generarReporte}><i className='fa fa-print fa-lg'/> Imprimir</button>
                      <button type='button' className='btn btn-sm' disabled={submitting } onClick={this.inicializarComponentes}>
                        <i className='fa fa-trash-o fa-lg'></i> Limpiar
                      </button>
                      <button type="button" disabled={this.state.esAprobadorForm} className='btn btn-sm' onClick={this.mostrarModal}>
                        <i className="fa fa-question-circle"></i> Solicitud Ap
                      </button>
                    </div>
                  </div>                  
                </Row>                
              </form>
                <ComponenteSolicitudAprobacion
                  visible={this.state.modalVisible}
                  title="Solicitante"
                  onClose={()=>{this.cerrarModal(this.state.socket)}}
                  usuario={this.state.usuario_final}
                  socket={this.state.socket}
                  mensajes={this.state.mensajes}
                  usuariosAprobadores={this.state.usuariosAprobadores}
                  tipo={this.state.tipoSolicitud}
                  tipoMostrar={'INGRESO'}
                  transaccionId= {this.state.transaccionId}
                  total_item={this.state.data_articulos.length}
                  total_valor={this.state.total_ingreso}
                  puedeSolicitar={this.state.puedeSolicitar}
              />
            </CuerpoForm>
          </ContenedorForm>
      );
  }
}

const selector = formValueSelector('form_inven04');

FormInven04 = reduxForm({
  form: 'form_inven04', enableReinitialize: true, validate
})(FormInven04);

FormInven04 = connect(
  state => ({
    initialValues: state.inicializacion_form.data,
    codigo_ingreso: selector(state, 'ingreso'),
    ingresoBodegaId: selector(state, 'codigo'),
    articulo: selector(state, 'articulo'),
    cantidad: selector(state, 'cantidad_item'),
    detalle_ingreso: selector(state, 'detalle_ing'),    
    permiso: state.sesion.valoresSesionForm.Permiso,
    idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
    permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
    diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
    formulario: state.sesion.valoresSesionForm.Formulario, //WILLY 2019-10-01
    fechaIngreso: selector(state, 'fecha'),//Cambios Aprobacion 20191030
    proveedor: selector(state, 'proveedor'),//Cambios Aprobacion 20191030
    bodega: selector(state,'bodega'),//Cambios Aprobacion 20191030
    observacion:selector(state, 'observacion'),//Cambios Aprobacion 20191030
    tipo:selector(state, 'tipo'), //Cambios Aprobacion 20191031
    tipoIngreso_valor: selector(state, 'tipoIngreso'),
    movimientoId: selector(state, 'movimientoId'),
  }),
  { cargar_ValoresIniciales, cargar_IngresoBodega, cambiar_VisualizacionLoading,
    generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm }
)(FormInven04);

export default FormInven04;